import { db } from '../../../db'
import {
  SETTINGS_ID_USER_SETTINGS,
  TABLE_USER_SETTINGS,
} from '../../../db/types'
import { UserSettings } from '../types'
import { useGetById } from '../../../db/hooks'

export const setUserSettings = async (
  userProfile: UserSettings
): Promise<void> => {
  await db
    .table(TABLE_USER_SETTINGS)
    .put({ id: SETTINGS_ID_USER_SETTINGS, ...userProfile })
}

export const useGetUserSettings = () =>
  useGetById<UserSettings>(TABLE_USER_SETTINGS, SETTINGS_ID_USER_SETTINGS)
